import { render, staticRenderFns } from "./PreviewForm6.vue?vue&type=template&id=6358df96&scoped=true"
import script from "./PreviewForm6.vue?vue&type=script&lang=ts"
export * from "./PreviewForm6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358df96",
  null
  
)

export default component.exports